/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '@ng-bootstrap/ng-bootstrap/pagination/pagination';
import * as i3 from '@ng-bootstrap/ng-bootstrap/pagination/pagination-config';
const styles_NgbPagination:any[] = ([] as any[]);
export const RenderType_NgbPagination:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_NgbPagination,data:{}});
function View_NgbPagination_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),7,'li',[['class',
      'page-item']],[[2,'disabled',(null as any)]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),4,'a',[['aria-label','First'],['class','page-link'],
          ['href','']],[[1,'tabindex',0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>!!_co.selectPage(1)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n          '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['aria-hidden','true']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['««'])),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:boolean = (!_co.hasPrevious() || _co.disabled);
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (_co.hasPrevious()? (null as any): '-1');
    _ck(_v,2,0,currVal_1);
  });
}
function View_NgbPagination_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),7,'li',[['class',
      'page-item']],[[2,'disabled',(null as any)]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),4,'a',[['aria-label','Previous'],['class','page-link'],
          ['href','']],[[1,'tabindex',0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>!!_co.selectPage((_co.page - 1))) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n          '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['aria-hidden','true']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['«'])),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:boolean = (!_co.hasPrevious() || _co.disabled);
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (_co.hasPrevious()? (null as any): '-1');
    _ck(_v,2,0,currVal_1);
  });
}
function View_NgbPagination_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'a',[['class',
      'page-link']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['...']))],(null as any),(null as any));
}
function View_NgbPagination_6(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class',
      'sr-only']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['(current)']))],(null as any),(null as any));
}
function View_NgbPagination_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'a',[['class',
      'page-link'],['href','']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>!!_co.selectPage((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n          ','\n          '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NgbPagination_6)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n        ']))],
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_1:any = ((<any>_v.parent).context.$implicit === _co.page);
        _ck(_v,3,0,currVal_1);
      },(_ck,_v) => {
        const currVal_0:any = (<any>_v.parent).context.$implicit;
        _ck(_v,1,0,currVal_0);
      });
}
function View_NgbPagination_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),7,'li',[['class',
      'page-item']],[[2,'active',(null as any)],[2,'disabled',(null as any)]],(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NgbPagination_4)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NgbPagination_5)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      ']))],(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_2:any = _co.isEllipsis(_v.context.$implicit);
    _ck(_v,3,0,currVal_2);
    const currVal_3:boolean = !_co.isEllipsis(_v.context.$implicit);
    _ck(_v,6,0,currVal_3);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (_v.context.$implicit === _co.page);
    const currVal_1:any = (_co.isEllipsis(_v.context.$implicit) || _co.disabled);
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
function View_NgbPagination_7(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),7,'li',[['class',
      'page-item']],[[2,'disabled',(null as any)]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),4,'a',[['aria-label','Next'],['class','page-link'],
          ['href','']],[[1,'tabindex',0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>!!_co.selectPage((_co.page + 1))) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n          '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['aria-hidden','true']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['»'])),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:boolean = (!_co.hasNext() || _co.disabled);
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (_co.hasNext()? (null as any): '-1');
    _ck(_v,2,0,currVal_1);
  });
}
function View_NgbPagination_8(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),7,'li',[['class',
      'page-item']],[[2,'disabled',(null as any)]],(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted((null as any),['\n        '])),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),4,'a',[['aria-label','Last'],['class','page-link'],
          ['href','']],[[1,'tabindex',0]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>!!_co.selectPage(_co.pageCount)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n          '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['aria-hidden','true']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['»»'])),(_l()(),i0.ɵted((null as any),['\n        '])),
      (_l()(),i0.ɵted((null as any),['\n      ']))],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:boolean = (!_co.hasNext() || _co.disabled);
    _ck(_v,0,0,currVal_0);
    const currVal_1:any = (_co.hasNext()? (null as any): '-1');
    _ck(_v,2,0,currVal_1);
  });
}
export function View_NgbPagination_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(2,[(_l()(),i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵeld(0,(null as any),
      (null as any),16,'ul',([] as any[]),[[8,'className',0]],(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
      i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NgbPagination_1)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n\n      '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NgbPagination_2)),
      i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),['\n      '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_NgbPagination_3)),
      i0.ɵdid(802816,(null as any),0,i1.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,
          i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n      '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_NgbPagination_7)),i0.ɵdid(16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n\n      '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,
          (null as any),View_NgbPagination_8)),i0.ɵdid(16384,(null as any),0,i1.NgIf,
          [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i0.ɵted((null as any),['\n    '])),(_l()(),i0.ɵted((null as any),['\n  ']))],
      (_ck,_v) => {
        var _co:i2.NgbPagination = _v.component;
        const currVal_1:any = _co.boundaryLinks;
        _ck(_v,4,0,currVal_1);
        const currVal_2:any = _co.directionLinks;
        _ck(_v,7,0,currVal_2);
        const currVal_3:any = _co.pages;
        _ck(_v,10,0,currVal_3);
        const currVal_4:any = _co.directionLinks;
        _ck(_v,13,0,currVal_4);
        const currVal_5:any = _co.boundaryLinks;
        _ck(_v,16,0,currVal_5);
      },(_ck,_v) => {
        var _co:i2.NgbPagination = _v.component;
        const currVal_0:any = ('pagination' + (_co.size? (' pagination-' + _co.size): ''));
        _ck(_v,1,0,currVal_0);
      });
}
export function View_NgbPagination_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'ngb-pagination',
      [['role','navigation']],(null as any),(null as any),(null as any),View_NgbPagination_0,
      RenderType_NgbPagination)),i0.ɵdid(573440,(null as any),0,i2.NgbPagination,[i3.NgbPaginationConfig],
      (null as any),(null as any))],(null as any),(null as any));
}
export const NgbPaginationNgFactory:i0.ComponentFactory<i2.NgbPagination> = i0.ɵccf('ngb-pagination',
    i2.NgbPagination,View_NgbPagination_Host_0,{disabled:'disabled',boundaryLinks:'boundaryLinks',
        directionLinks:'directionLinks',ellipses:'ellipses',rotate:'rotate',collectionSize:'collectionSize',
        maxSize:'maxSize',page:'page',pageSize:'pageSize',size:'size'},{pageChange:'pageChange'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/venyou-stripe/src/$$_gendir/~/@ng-bootstrap/ng-bootstrap/pagination/pagination.ngfactory.ts